import React from 'react';
import { motion } from 'framer-motion';
type HeroProps = {
  onStart: () => void;
};
const badges = ['Gratuito', '1 minuto', 'Resultado personalizado'];
export function Hero({
  onStart
}: HeroProps) {
  return <section className="relative min-h-[100svh] w-full bg-beige-50" data-id="element-45" data-mp="9lv0spiridvb">
      <div className="mx-auto grid min-h-[100svh] w-full max-w-7xl grid-cols-1 lg:grid-cols-2" data-id="element-46" data-mp="4lyvmmybwge6">
        <div className="order-2 flex items-center px-6 pb-20 pt-12 sm:px-10 lg:order-1 lg:px-16 lg:py-24" data-id="element-47" data-mp="129h5y27n1qka">
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1.1,
          ease: [0.22, 1, 0.36, 1]
        }} className="w-full max-w-xl" data-id="element-48" data-mp="xanra6gm7tij">
            <p className="text-[0.7rem] uppercase tracking-[0.32em] text-sage-600" data-id="element-49" data-mp="nbexpepnwgwp">
              Diagnóstico facial
            </p>

            <h1 className="mt-8 font-serif text-[2.75rem] font-light leading-[1.05] tracking-tight text-warmgray-800 sm:text-6xl lg:text-[4.25rem]" data-id="element-50" data-mp="3czfme2gnud7m">
              ¿Qué necesita
              <br data-id="element-51" data-mp="3j923fiwkdgsw" />
              realmente tu piel?
            </h1>

            <p className="mt-8 max-w-md text-base leading-relaxed text-warmgray-600 sm:text-lg" data-id="element-52" data-mp="3o7vlzpqpjxzx">
              Descubrilo en solo 60 segundos con un diagnóstico personalizado.
            </p>

            <button type="button" onClick={onStart} className="mt-12 w-full rounded-full bg-sage-700 px-10 py-5 text-sm uppercase tracking-[0.18em] text-beige-50 transition-all duration-500 ease-calm hover:bg-sage-800 sm:w-auto" data-id="element-53" data-mp="3e8whmjcz6oiq">
              Comenzar diagnóstico
            </button>

            <ul className="mt-10 flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:gap-8" data-id="element-54" data-mp="2qloh0eqhs3n1">
              {badges.map(badge => <li key={badge} className="flex items-center gap-3 text-sm font-light text-warmgray-500" data-id="element-55" data-mp="2hj5ddsevtmzq">
                  <span aria-hidden="true" className="text-sage-500" data-id="element-56" data-mp="2lk8vklkejv44">
                    ✓
                  </span>
                  {badge}
                </li>)}
            </ul>
          </motion.div>
        </div>

        <div className="relative order-1 h-[52vh] min-h-[320px] w-full overflow-hidden lg:order-2 lg:h-auto lg:min-h-[100svh]" data-id="element-57" data-mp="n9i35afexat2">
          <motion.img initial={{
          opacity: 0,
          scale: 1.06
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1.6,
          ease: [0.22, 1, 0.36, 1]
        }} src="https://cdn.magicpatterns.com/patterns/generated-images/215bf652-8901-4d85-b445-20d6bdf8d69e.jpg" alt="Mujer aplicándose crema facial junto a una ventana con luz natural" className="h-full w-full object-cover object-center" data-id="element-58" data-mp="ddnfg0wc0pjf" />
          <div aria-hidden="true" className="pointer-events-none absolute inset-0 bg-beige-50/10" data-id="element-59" data-mp="x3h260k6wegs" />
        </div>
      </div>
    </section>;
}